export default __webpack_public_path__ + "static/media/ashe-bg-large.d9095d72.jpg";